import React from "react";
import "./ScrollToTopButton.css";

export default function ScrollToTopButton() {
  const handleClick = () => {
    window.scrollTo({
    top: 0,
    behavior: "smooth",
  });
  };

  return (
    <button className="scroll-to-top" onClick={handleClick}>
      &#8679;
    </button>
  );
}
